import React,{useState, useEffect} from "react";
import { Link } from "@StarberryUtils";
import ScrollAnimation from "react-animate-on-scroll";
import { Button, Form, Container, FormControl, Row, InputGroup, Col } from "react-bootstrap";
import "./HomeBookConsultation.scss";
import ImageTransform from "@Components/common/ggfx-client/module/components/image-transform";
import PersonImgDesktop1 from "../../../images/home/mark-crampton-smith-d.png";
import PersonImgTablet1 from "../../../images/home/mark-crampton-smith-d.png";
import PersonImgMobile1 from "../../../images/home/mark-crampton-smith-d.png";
import CustomButton from "@Components/calendly/book-a-video-call"
import PersonImgDesktop2 from "../../../images/home/catherine-witt-d.png";
import PersonImgTablet2 from "../../../images/home/catherine-witt-d.png";
import PersonImgMobile2 from "../../../images/home/catherine-witt-d.png";
import ReactMarkdown from "react-markdown"
import {
    BAC_PAGE_URL, SALE_PAGE_URL
     } from "@Components/common/site/constants";
import GetURL from '@Components/common/site/get-url';
import { FormLocation } from '@Components/icon/icon';
import ModelForm from "@Components/ModelForm/ModelForm";
import { inViewOptions } from '../../../Components/utils/animations';
import { motion } from "framer-motion";
import { InView } from "react-intersection-observer";
import { useStaticQuery, graphql } from "gatsby";
import SearchInputBox from '@Components/SearchResult/predictive-search/search-inputbox';
import $ from "jquery";
import { navigate } from "@reach/router";
import {ImageModule} from "@Components/common/Image_Module";

const containerVariants = {
    hidden: {
        opacity: 0
    },
    visible: {
        opacity: 1,
        transition: {
            staggerChildren: 0.4,
            ease: [0.33, 1, 0.68, 1],
            duration: 0.4
        }
    }
}

const HomeBookConsultation = (props) => {
    const dataglobal = useStaticQuery(graphql`
query{
glstrapi {
  globalConfig(publicationState: LIVE) {
    Choose_Team {
        Email
        Name
        Designation
        Image {
            alternativeText
            url
        }
        Book_A_Video
        imagetransforms
        ggfx_results {
            id
            content_type
            transforms
            src_import_url
            src_cftle
            field
        }
        id
    }
  }
}
}
`);   
useEffect(() => {
    let url = "/";

    $(".sales_btn").click(function() {
        $("html, body").scrollTop(0);
        var searcValue = $(".searchinputbox_helpform .react-autosuggest__input").val().split(', ').join('-').replace(/ /g,"-").replace(/'/g,"").toLowerCase();
        if(searcValue !== "") {
            url = "in-"+searcValue+"/"
        } else {
            url = "in-oxford-and-thame/"
        }
        navigate("/property/for-sale/"+url);
    })

    $(".rent_btn").click(function () {
      $("html, body").scrollTop(0);
      var searcValue = $(".searchinputbox_helpform .react-autosuggest__input").val().split(', ').join('-').replace(/ /g, "-").replace(/'/g, "").toLowerCase();
      if (searcValue !== "") {
        url = "in-" + searcValue + "/"
      } else {
        url = "in-oxford-and-thame/"
      }
      navigate("/property/to-rent/" + url);
    })
  }, []); 
const [property_rezise_images, setPropertyReziseImages] = useState(dataglobal?.glstrapi?.globalConfig?.Choose_Team?.Image?.url)
let processedImages = JSON.stringify({});
if (dataglobal?.glstrapi?.globalConfig?.Choose_Team?.Image_Transforms) {
    processedImages = dataglobal?.glstrapi?.globalConfig?.Choose_Team?.Image_Transforms;
}
    return (
        <InView {...inViewOptions}>
            {({ ref, inView }) => {
                return (
                    <motion.section
                        ref={ref}
                        initial="hidden"
                        animate={inView ? "visible" : "hidden"}
                        variants={containerVariants}
                    >
                        <React.Fragment>
                            <section className="home-book-consultation help-module">
                                <ScrollAnimation animateIn='fadeInUp' animateOnce={true}>
                                    <Container>
                                        <Row>
                                            <Col lg={7}>
                                                <div className="block-head">
                                                    <ScrollAnimation animateOnce={true} animateIn='fadeIn'><h2>{props.Title}</h2></ScrollAnimation>
                                                    <ScrollAnimation animateOnce={true} animateIn='fadeIn'>
                                                        <ReactMarkdown source={props?.Content} allowDangerousHtml />
                                                    </ScrollAnimation>
                                                </div>
                                                <div className="helpform">
                                                <form>
                                                <div className="searchinputbox_helpform">
                                                    <SearchInputBox />
                                                </div>
                                                <Button className="button-submit btn btn-primary sales_btn">Buy</Button>
                                                        <Button className="button-submit btn btn-primary rent_btn">Rent</Button>
                                                        </form>
                                                    {/* <form>
                                                        <div className="input-wrap">
                                                            <div className="ico-loca"><FormLocation /></div>
                                                            <input type="text" placeholder="Enter Property Address" />
                                                        </div>
                                                        <button type="submit" class="button-submit btn btn-primary sales_btn">Buy</button>
                                                        <button type="submit" class="button-submit btn btn-primary rent_btn">Rent</button>
                                                    </form> */}
                                                </div>
                                                <div className="btn-group-block btn-bg-dark d-none d-lg-flex">
                                                    {props.Cta_Label_1 && props.Cta_Url_1.Alias &&
                                                        <ScrollAnimation animateOnce={true} animateIn='fadeIn'>
                                                            <GetURL class={"btn btn-primary-bg"} label={props.Cta_Label_1} alias={props.Cta_Url_1.Alias} />
                                                        </ScrollAnimation>
                                                    }
                                                    {props.Cta_Label_2 && props.Cta_Url_1.Alias &&
                                                        <ScrollAnimation animateOnce={true} animateIn='fadeIn'>
                                                            <GetURL class={"btn btn-outline-bg"} label={props.Cta_Label_2} alias={props.Cta_Url_2.Alias} />
                                                        </ScrollAnimation>
                                                    }
                                                </div>
                                            </Col>
                                            <Col lg={5} className=" d-none d-lg-block">
                                                <div className="person-detail person2">
                                                    <div className="person-info">
                                                        <div className="person-img">
                                                            <ScrollAnimation animateOnce={true} animateIn='fadeIn'>
                                                                {/* <picture>
                                                                    <source media="(min-width:992px)" srcSet={PersonImgDesktop2} />
                                                                    <source media="(min-width:768px)" srcSet={PersonImgTablet2} />
                                                                    <img src={PersonImgMobile2} alt="" />
                                                                </picture> */}
                                                                    <ImageModule ImageSrc={dataglobal?.glstrapi?.globalConfig?.Choose_Team?.Image} attr={{ alt: dataglobal?.glstrapi?.globalConfig?.Choose_Team?.Name }} ggfx_results={dataglobal?.glstrapi?.globalConfig?.Choose_Team.ggfx_results} imagename="team.Image.choose" strapi_id={dataglobal?.glstrapi?.globalConfig?.Choose_Team?.id} />
                                                                   {/* <ImageTransform imagesources={property_rezise_images} renderer="srcSet" imagename='team.Image.choose'
                                                                        attr={{ alt: dataglobal?.glstrapi?.globalConfig?.Choose_Team?.Image?.alternativeText, className: '' }}
                                                                        imagetransformresult={processedImages} id={dataglobal?.glstrapi?.globalConfig?.Choose_Team?.id} ></ImageTransform> */}
                                                            </ScrollAnimation>
                                                        </div>
                                                        <div className="person-content">
                                                        <ScrollAnimation animateOnce={true} animateIn='fadeIn'><p className="name">{dataglobal?.glstrapi?.globalConfig?.Choose_Team?.Name}</p></ScrollAnimation>
                                                            <ScrollAnimation animateOnce={true} animateIn='fadeIn'><p className="designation">{dataglobal?.glstrapi?.globalConfig?.Choose_Team?.Designation}</p></ScrollAnimation>
                                                            <ScrollAnimation animateOnce={true} animateIn='fadeIn'><p className="person-links">{dataglobal?.glstrapi?.globalConfig?.Choose_Team?.Email ? <ModelForm page="" Name={dataglobal?.glstrapi?.globalConfig?.Choose_Team?.Name} mailid={dataglobal?.glstrapi?.globalConfig?.Choose_Team?.Email} /> : null}  {dataglobal?.glstrapi?.globalConfig?.Choose_Team?.Book_A_Video ? <> / <CustomButton url={dataglobal?.glstrapi?.globalConfig?.Choose_Team?.Book_A_Video} /> </> : ""}</p></ScrollAnimation>
                                                        </div>
                                                    </div>
                                                </div>
                                            </Col>
                                        </Row>
                                        <Row className="d-lg-none">
                                            <Col lg={12}>
                                                <div className="person-detail person2">
                                                    <div className="person-info">
                                                        <div className="person-img">
                                                            <ScrollAnimation animateOnce={true} animateIn='fadeIn'>
                                                                {/* <picture>
                                                                    <source media="(min-width:992px)" srcSet={PersonImgDesktop2} />
                                                                    <source media="(min-width:768px)" srcSet={PersonImgTablet2} />
                                                                    <img src={PersonImgMobile2} alt="" />
                                                                </picture> */}
                                                                <ImageModule ImageSrc={dataglobal?.glstrapi?.globalConfig?.Choose_Team?.Image} attr={{ alt: dataglobal?.glstrapi?.globalConfig?.Choose_Team?.Name }} ggfx_results={dataglobal?.glstrapi?.globalConfig?.Choose_Team.ggfx_results} imagename="team.Image.choose" strapi_id={dataglobal?.glstrapi?.globalConfig?.Choose_Team?.id} />
                                                                                                                                   {/* <ImageTransform imagesources={property_rezise_images} renderer="srcSet" imagename='team.Image.choose'
                                                                        attr={{ alt: dataglobal?.glstrapi?.globalConfig?.Choose_Team?.Image?.alternativeText, className: '' }}
                                                                        imagetransformresult={processedImages} id={dataglobal?.glstrapi?.globalConfig?.Choose_Team?.id} ></ImageTransform> */}
                                                            </ScrollAnimation>
                                                        </div>
                                                        <div className="person-content">
                                                            <ScrollAnimation animateOnce={true} animateIn='fadeIn'><p className="name">{dataglobal?.glstrapi?.globalConfig?.Choose_Team?.Name}</p></ScrollAnimation>
                                                            <ScrollAnimation animateOnce={true} animateIn='fadeIn'><p className="designation">{dataglobal?.glstrapi?.globalConfig?.Choose_Team?.Designation}</p></ScrollAnimation>
                                                            <ScrollAnimation animateOnce={true} animateIn='fadeIn'><p className="person-links">{dataglobal?.glstrapi?.globalConfig?.Choose_Team?.Email ? <ModelForm page="" Name={dataglobal?.glstrapi?.globalConfig?.Choose_Team?.Name} mailid={dataglobal?.glstrapi?.globalConfig?.Choose_Team?.Email} /> : null}  {dataglobal?.glstrapi?.globalConfig?.Choose_Team?.Book_A_Video ? <> / <CustomButton url={dataglobal?.glstrapi?.globalConfig?.Choose_Team?.Book_A_Video} /> </> : ""}</p></ScrollAnimation>
                                                        </div>
                                                    </div>
                                                </div>
                                            </Col>
                                        </Row>
                                        <Row className="d-lg-none">
                                            <Col lg={5}>
                                                <div className="btn-group-block btn-bg-dark ">
                                                    <ScrollAnimation animateOnce={true} animateIn='fadeIn'><Link className="btn btn-primary-bg" to={BAC_PAGE_URL.alias}>Book a Consultation</Link></ScrollAnimation>
                                                    <ScrollAnimation animateOnce={true} animateIn='fadeIn'><Link className="btn btn-outline-bg" to={SALE_PAGE_URL.alias}>Find a Property</Link></ScrollAnimation>
                                                </div>
                                            </Col>
                                        </Row>
                                    </Container>
                                </ScrollAnimation>
                            </section>
                        </React.Fragment>
                    </motion.section>
                )
            }}
        </InView>
    )
}

export default HomeBookConsultation;